import React from "react"
import { Translate } from "utils/i18n-shim"
import { Stack, Typography } from "@mui/material"
import kebabCase from "lodash/kebabCase"
import moment from "moment"

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T[\d:.+Z-]+)?$/

const formatChange = (value) => {
  if (typeof value === "string" && ISO_DATE_RE.test(value)) {
    if (value.length > 10) {
      return moment(value).format("DD.MM.YYYY HH:mm:ss")
    }
    return moment(value).format("DD.MM.YYYY")
  }

  if (Array.isArray(value)) {
    return JSON.stringify(value)
  }

  return value !== null ? (
    value.toString()
  ) : (
    <Translate className="value" value="blank" />
  )
}

const ChangesCell = ({ label, labelPrefix, changeset }) => {
  const [from, to] = changeset
  const labelValue = labelPrefix ? `${labelPrefix}.${kebabCase(label)}` : label

  return (
    <Stack key={label} direction="row" spacing={0.5}>
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 500,
          color: "grey.600"
        }}
      >
        <Translate value={labelValue} />:
      </Typography>
      <Typography sx={{ fontSize: "0.75rem" }}>
        {formatChange(from)}, {formatChange(to)}
      </Typography>
    </Stack>
  )
}

export const renderChangesCell = (info, labelPrefix) => {
  const changes = info.getValue()
  const entries = Object.entries(changes || {})
  const comment = info.row.original.comment

  if (entries.length === 0 && comment) {
    return (
      <Stack direction="row" spacing={0.5}>
        <Typography fontSize="0.75rem" fontWeight={500} color="grey.600">
          <Translate value="comment" />:
        </Typography>
        <Typography fontSize="0.75rem">{comment}</Typography>
      </Stack>
    )
  }

  if (entries.length === 0) {
    return (
      <Typography sx={{ fontSize: "0.75rem" }}>
        <Translate value="record-history.no-visible-changes" />
      </Typography>
    )
  }

  return (
    <>
      {entries.map(([label, changes]) => (
        <ChangesCell
          key={label}
          label={label}
          labelPrefix={labelPrefix}
          changeset={changes}
        />
      ))}
    </>
  )
}
